import { render, staticRenderFns } from "./tool_adapt_product.vue?vue&type=template&id=70bc63ce&scoped=true&"
import script from "./tool_adapt_product.vue?vue&type=script&lang=js&"
export * from "./tool_adapt_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc63ce",
  null
  
)

export default component.exports